import * as React from 'react';
import c from 'classnames';
import styles from './css/InputField.css';

const Label = ({ children, ...restProps }) => (
  <label
    htmlFor={restProps.name} className={styles.input_label} 
  >
    <span>{restProps.name}:</span>
    {children}
  </label>
);

const Input = ({ ...restProps }) => (
  <input
    className={c(styles.input)}
    id={restProps.name}
    {...restProps}
  />
);

export const InputField = ({ label, ...restProps }) => (
  <>
    {label && (
      <Label {...restProps}>
        <Input {...restProps} />
      </Label>
    )}
    {!label && (<Input {...restProps} />)}
  </>
);
